
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationItems extends Mixins(OperationComponentMixin) {
  get destination(): string | null {
    return this.operationChild?.shipmentDestination || null;
  }

  get notes(): string | null {
    return this.operationChild?.shipmentNotes || null;
  }

  get shipmentIconColor(): string {
    if (this.partialShipment) return 'statusDone';
    return this.shipmentReady ? 'statusDone' : 'grey lighten-2';
  }

  get shipmentIcon(): string {
    // Se ancora non sono state impostate date...
    if (!this.partialShipmentDate && !this.deliveryDate) {
      // ... mostra il furgone vuoto
      return 'mdi-truck-outline';
    }

    // Se la spedizione finale è completa...
    if (this.shipmentCompleted) {
      // ... mostra il furgone pieno se non è stata completata anche una parziale,
      // altrimenti mostra il furgone con il segno -.
      return this.partialShipmentCompleted ? 'mdi-truck-minus' : 'mdi-truck';
    }

    // Se la spedizione finale NON è completa
    // e la spedizione parziale non è avvenuta...
    if (!this.shipmentCompleted
      && !this.partialShipmentDate
      && !this.partialShipment
      && !this.partialShipmentCompleted) {
      // ... la spedizione finale in corso (data impostata e forse confermata)
      // Mostra il furgone pieno
      return 'mdi-truck';
    }

    // La spedizione finale NON è completa
    // e sta avvenendo o è avvenuta la spedizione parziale

    return this.deliveryDate && this.partialShipmentCompleted ? 'mdi-truck-minus' : 'mdi-truck-cargo-container';
  }

  get tooltipText(): string {
    let text = '';

    if (this.shipmentCompleted) {
      text += this.partialShipmentCompleted
        ? 'Spedizione parziale e finale completata'
        : 'Spedizione finale completata';
    } else

    if (this.deliveryDate
      && (this.partialShipmentCompleted || !this.partialShipmentDate)
    ) {
      text += this.shipmentReady
        ? 'Spedizione finale concordata'
        : 'Spedizione finale non ancora concordata';
    } else

    if (this.partialShipmentCompleted) {
      text += 'Spedizione parziale completata';
    } else if (this.partialShipmentDate) {
      text += this.partialShipment
        ? 'Spedizione parziale concordata'
        : 'Spedizione parziale non ancora concordata';
    } else {
      text += 'Spedizione non ancora concordata';
    }

    return text;
  }

  get tooltipColor(): string {
    if (this.shipmentCompleted) return 'success';
    if (this.shipmentReady) return '';
    if (this.deliveryDate) return '';
    if (this.partialShipmentCompleted) return 'success';
    if (this.partialShipment) return '';
    if (this.partialShipmentDate) return '';
    return 'error';
  }

  get partialShipment(): boolean {
    return this.operationChild?.partialShipment === true;
  }

  get dateText(): string {
    // È impostata una data di spedizione finale
    if (this.deliveryDate) {
      // Se non è impostata una data di spedizione parziale...
      if (!this.partialShipmentDate) {
        // ... ritorna la data di spedizione finale
        return this.deliveryDate;
      }

      // Se è impostata una data di spedizione parziale
      // e la spedizione parziale non è completata,
      // ritorna quella parziale, altrimenti quella finale.
      return this.partialShipmentCompleted
        ? this.deliveryDate
        : this.partialShipmentDate;
    }

    if (this.partialShipmentDate) return this.partialShipmentDate;

    return 'da definire';
  }

  get dateClass(): string {
    if (this.deliveryDate || this.partialShipmentDate) return '';
    return 'grey--text text--lighten-2';
  }

  get dateTooltipText(): string {
    let text = '';

    if (this.shipmentCompleted) {
      text += this.partialShipmentCompleted
        ? 'Spedizione parziale e finale completata'
        : 'Spedizione finale completata';
    } else

    if (this.deliveryDate
      && (this.partialShipmentCompleted || !this.partialShipmentDate)
    ) {
      text += this.shipmentReady
        ? 'Data concordata per la spedizione finale'
        : 'Data prevista per la spedizione finale (non confermata)';
    } else

    if (this.partialShipmentCompleted) {
      text += 'Spedizione parziale completata';
    } else if (this.partialShipmentDate) {
      text += this.partialShipment
        ? 'Data concordata per la spedizione parziale'
        : 'Data prevista per la spedizione parziale (non confermata)';
    } else {
      text += 'Data prevista per la spedizione da definire';
    }

    return text;
  }

  // get dateTooltipColor(): string {
  // }

  get partialShipmentDate(): string | null {
    return this.operationChild
      && this.operationChild.partialShipmentDate
      && moment(this.operationChild.partialShipmentDate).isValid()
      ? moment(this.operationChild.partialShipmentDate).format('L')
      : null;
  }

  get shipmentPicked(): boolean {
    return this.operationChild?.shipmentPicked === true;
  }

  get shipmentReady(): boolean {
    return this.operationChild?.shipmentReady === true;
  }

  get shipmentSent(): boolean {
    return this.operationChild?.flatTasks.includes('M=c') || false;
  }

  get deliveryDate(): string | null {
    return this.operationChild
      && this.operationChild.deliveryDate
      && moment(this.operationChild.deliveryDate).isValid()
      ? moment(this.operationChild.deliveryDate).format('L')
      : null;
  }

  get firstColumnClass(): string {
    if (this.shipmentPicked) return 'completed';
    if (this.destination) return 'selected';
    return '';
  }

  get firstColumnTooltipText() {
    if (this.notes
      && this.isCurrentUserOwnerOrRequester
      && this.hasPermission('taskm.notes.show')
    ) return this.notes;
    if (this.shipmentPicked) return 'Il materiale è pronto';

    return 'Il materiale non è pronto';
  }

  get partialShipmentCompleted(): boolean {
    return this.operationChild?.partialShipmentCompleted === true;
  }

  get shipmentCompleted(): boolean {
    return this.operationChild?.shipmentCompleted === true;
  }

  get lastColumnClass(): string {
    // Se l'intero Task M è completo o in errore, collora la colonna
    if (this.operationChild?.flatTasks.includes('M=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('M=e')) return 'error';

    if (this.shipmentCompleted) return 'completed';
    if (this.shipmentReady) return this.partialShipmentCompleted ? 'yellow-green' : 'yellow';

    if (this.partialShipmentCompleted) return 'white-green';
    if (this.partialShipment) return 'white-yellow';

    return '';
  }

  onEdit() {
    console.log('OperationItems: onEdit()'); // eslint-disable-line no-console
    this.$emit('edit');
  }
}
